import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function CommerceWhy() {
  return <section className="py-24 bg-paper border-b border-subtle-gray" data-id="element-778">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-779">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-780">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-781">
            Why Commerce Families Choose Storm
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-782">
          {['Worth the short trip for premium martial arts instruction', 'A structured curriculum that builds real confidence and discipline', 'Clean, modern training facility', 'Programs for the whole family, ages 3 and up'].map((reason, idx) => <div key={idx} className="flex items-start gap-4 bg-off-white p-6 rounded-2xl border border-subtle-gray" data-id="element-783">
              <CheckCircle2 className="w-8 h-8 text-storm-red shrink-0" data-id="element-784" />
              <p className="text-lg text-ink font-medium" data-id="element-785">{reason}</p>
            </div>)}
        </div>
      </div>
    </section>;
}